(() => {
  const strip = document.querySelector('[data-elv-category-menu]');
  const countryInput = document.querySelector('[data-elv-country]');
  if (!strip || !countryInput) return;
  const templates = new Map(Array.from(document.querySelectorAll('[data-elv-strip-template]'), node => [node.dataset.elvStripTemplate, node]));
  const status = strip.querySelector('[data-delivering]');
  let current = '';
  const update = destination => {
    const source = templates.get(destination);
    const known = !!source;
    strip.hidden = !known;
    if (current !== destination) {
      strip.querySelector('[data-elv-category-links]').replaceChildren(...(source ? [source.content.cloneNode(true)] : []));
    }
    status.textContent = known ? status.dataset.delivering.replace('__COUNTRY__', source.dataset.countryName) : '';
    current = known ? destination : '';
    const option = Array.from(countryInput.options).find(node => node.dataset.country === current);
    countryInput.value = option ? option.value : '';
    if (known) {
      try { localStorage.setItem('elvDestinationCountry', current); } catch {}
    }
    strip.querySelectorAll('.qcs-tab').forEach(link => link.classList.toggle('qcs-tab--active', new URL(link.href).pathname === location.pathname));
  };
  // An explicit Homepage click starts a fresh destination selection.
  const root = new URL(document.querySelector('.logo a')?.href || '/', location.origin).pathname;
  const resetDestination = () => {
    try { localStorage.removeItem('elvDestinationCountry'); localStorage.removeItem('elvSearchCountry'); } catch {}
    document.dispatchEvent(new CustomEvent('elv:destination', {detail:{country:'', source:'homepage'}}));
  };
  document.addEventListener('click', event => {
    const link = event.target.closest('a[href]');
    if (!link || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || link.target === '_blank') return;
    const url = new URL(link.href, location.origin);
    if (url.origin === location.origin && url.pathname === root && !url.search && !url.hash) {
      resetDestination();
      try { sessionStorage.setItem('elvFreshHomepage', '1'); } catch {}
    }
  });
  const consumeHomepageReset = () => {
    if (location.pathname !== root) return;
    try { if (sessionStorage.getItem('elvFreshHomepage') === '1') { sessionStorage.removeItem('elvFreshHomepage'); resetDestination(); } } catch {}
  };
  window.addEventListener('pageshow', consumeHomepageReset);
  consumeHomepageReset();
  const params = new URLSearchParams(location.search);
  let saved = '';
  try { saved = localStorage.getItem('elvDestinationCountry') || (localStorage.getItem('elvSearchCountry') || '').replace(/^Expressluv /, '').toLowerCase(); } catch {}
  const pageCountry = strip.dataset.pageCountry || countryInput.selectedOptions[0]?.dataset.country;
  update(pageCountry || params.get('country') || saved);
  document.addEventListener('elv:destination', event => update(event.detail.country));
  countryInput.addEventListener('change', () => update(countryInput.selectedOptions[0]?.dataset.country || ''));
  window.addEventListener('storage', event => { if (event.key === 'elvDestinationCountry') update(event.newValue || ''); });
  strip.querySelectorAll('[data-elv-change-country]').forEach(button => button.addEventListener('click', () => {
    countryInput.focus();
    try { countryInput.showPicker(); } catch {}
  }));
  const categoriesButton = strip.querySelector('[data-elv-open-categories]');
  categoriesButton.addEventListener('click', () => {
    const open = strip.classList.toggle('elv-categories-open');
    categoriesButton.setAttribute('aria-expanded', String(open));
  });
})();
